import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Localhost development: enable emulator if available, else disable domain checks
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
if (isLocalhost && process.env.NODE_ENV === 'development') {
  try {
    // Try to use Firebase Emulator Suite if running on port 9099
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    console.log('✅ Using Firebase Auth Emulator (localhost:9099)');
  } catch (err) {
    // Emulator not available - provide setup instructions
    console.warn('⚠️ Firebase Auth Emulator not running. For local dev auth, either:');
    console.warn('   1. Add http://localhost:3000 to Firebase Console > Auth > Settings > Authorized domains');
    console.warn('   2. OR start Firebase Emulator: firebase emulators:start');
  }
}
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

// Firebase Analytics removed — Installations API blocked (403). GA4 via window.gtag handles all events.
export const analyticsReady = Promise.resolve(null);
export const analytics = null;

googleProvider.setCustomParameters({ prompt: 'select_account' });

export default app;
